import React, { useEffect } from 'react';
import axios from 'axios';
import appconfig from "./../appconfig.json";
import { Stack, Spinner, PrimaryButton } from '@fluentui/react';
import LocalPreview from './LocalPreview';
import LocalSettings from './LocalSettings';
import '../welcome.css';
import {
  VideoDeviceInfo,
  AudioDeviceInfo,
  LocalVideoStream,
  DeviceManager,
  CallAgent,
  CallEndReason
} from '@azure/communication-calling';
import {
  configurationStackTokens,
  buttonStyle,
  localSettingsContainerStyle,
  mainContainerStyle,
  fullScreenStyle,
  verticalStackStyle
} from './styles/Configuration.styles';

import 'bootstrap/dist/css/bootstrap.css';
import setLanguage from 'translation';
import {displayActivateAlert} from "../Utils/helpers";

export interface ConfigurationScreenProps {
  userId: string;
  groupId: string;
  callAgent: CallAgent;
  deviceManager: DeviceManager;
  setupCallClient(unsupportedStateHandler: () => void): void;
  setupCallAgent(displayName: string): void;
  setGroup(groupId: string): void;
  startCallHandler(): void;
  unsupportedStateHandler: () => void;
  callEndedHandler: (reason: CallEndReason) => void;
  videoDeviceList: VideoDeviceInfo[];
  audioDeviceList: AudioDeviceInfo[];
  setVideoDeviceInfo(device: VideoDeviceInfo): void;
  setAudioDeviceInfo(device: AudioDeviceInfo): void;
  mic: boolean;
  setMic(mic: boolean): void;
  setLocalVideoStream(stream: LocalVideoStream | undefined): void;
  localVideoRendererIsBusy: boolean;
  videoDeviceInfo: VideoDeviceInfo;
  audioDeviceInfo: AudioDeviceInfo;
  localVideoStream: LocalVideoStream;
  screenWidth: number;
  meetingID: string;
  meetingLink: string;
  fullName: string;
  meetingStartTime: string;
  setMeetingID(meetingID: string): void;
  setMeetingLink(meetingLink: string): void;
  setMeetingStartTime(meetingStartTime: string): void;
  setToken(token:string): void;
  setFullName(fullName:string): void;
  setMobile(mobile:string):void;
}
let callStarted: boolean = false;
const loadDevices = function () {
  navigator.mediaDevices.enumerateDevices().then(function (devices) {
    devices.forEach(function (device) {
      // console.log(device.kind + ": " + device.label +" id = " + device.deviceId);
      const deviceType = device.kind;
      if (device.deviceId == "default" || device.deviceId == "communications") return;
      if (deviceType == 'audioinput') {
        const option = document.createElement("option");
        option.text = device.label;
        option.value = device.deviceId;
        document.getElementById('micList')?.appendChild(option);
      } else if (deviceType == 'audiooutput') {
        const option = document.createElement("option");
        option.text = device.label;
        option.value = device.deviceId;
        document.getElementById('speakerList')?.appendChild(option);
      }
      else if (deviceType == 'videoinput') {
        const option = document.createElement("option");
        option.text = device.label;
        option.value = device.deviceId;
        document.getElementById('cameraList')?.appendChild(option);
      }
    });
  })


}




const checkPermissions = () => {
  navigator.permissions.query({ name: 'camera' })
    .then((permission) => {
      console.log("camera state", permission.state)
      if (permission.state != "granted") {
        const ele = document.getElementById('cameraState')
        if (ele) {
          ele.style.display = '';
        }
      } else {
        const ele = document.getElementById('cameraList')
        if (ele) {
          ele.style.display = '';
        }
      }
    });

  navigator.permissions.query({ name: 'microphone' })
    .then((permission) => {
      console.log("microphone state", permission.state);
      if (permission.state != "granted") {
        const ele = document.getElementById('microphoneState');
        if (ele) {
          ele.style.display = '';
        }
      } else {
        const ele = document.getElementById('micList');
        const eleSpeaker = document.getElementById('speakerListDiv');

        if (ele) {
          ele.style.display = '';
        }

        if (eleSpeaker) {
          eleSpeaker.style.display = '';
        }
      }
    });
}

const requestPermission = (media: string) => {

  if (media == "microphone") {

    navigator.mediaDevices.getUserMedia({ audio: true, video: false })
      .then(function (stream) {
        window.location.reload();
      });
  }
  if (media == "camera") {

    navigator.mediaDevices.getUserMedia({ audio: false, video: true })
      .then(function (stream) {
        window.location.reload();
      });
  }
  loadDevices();
}







export default (props: ConfigurationScreenProps): JSX.Element => {
  useEffect(() => {
    loadDevices();
    checkPermissions();
    let language = localStorage.getItem("lang")
    console.log("kiro",language)
    setLanguage(language);
  }, []);

  const spinnerLabel = 'Initializing call client...';
  const buttonText = 'بدء الاتصال';
  const { setupCallClient, unsupportedStateHandler,setFullName,setToken,setMobile, setMeetingID, setMeetingLink, setMeetingStartTime } = props;

  useEffect(() => {
    setupCallClient(unsupportedStateHandler);
  }, [setupCallClient, unsupportedStateHandler]);

  const initiateNewCall = (fullName: string , mobile: string, nin: string , token: string) => {
    let browser =  window["getBrowser"](); 
    let mic = document.getElementById('micList') as HTMLSelectElement;
    if(mic.value == "" && browser != "Safari" ){
      //alert("حتى نتمكن من خدمتك الرجاء تفعيل الكاميرا والميكروفون");
      displayActivateAlert();
      return;
    }

    let serviceType = "gosi-establishment";
    const requestBody = {
      "fullName": fullName,
      "serviceType": serviceType,
      "mobileNumber": mobile,
      "nin": nin
    };

    const config = {
      headers: {
        api_token: token
      }
    };

    const url = appconfig.azure_url + "/api/customer-meeting";
    axios.post(url, requestBody , config).then(response => {
      let meetingID: string = response.data.id;
      let meetingLink: string = response.data.meetingLink;
      setMeetingID(meetingID);
      setMeetingLink(meetingLink);
      setToken(token);
      setFullName(fullName);
      setMobile(mobile);
      var time = new Date();
      setMeetingStartTime(time.getTime().toString());
      //meetingLink = meetingLink.replace("https://gosivvwebapp-as.azurewebsites.net", "http://localhost:3000");
      window.location.href = meetingLink + "&meetingID=" + response.data.id + "&fullname=" + fullName + "&serviceType=" + serviceType;
    
    })
  }

  const fetchEstablishmentToken = (fullName: string, mobile: string, registrationNo: string) =>{
    let token_url = appconfig.azure_reports_url + "/api/establishmenttoken";
    alert("establish url is"+token_url)
    const body = {
      "FullName": fullName,
      "MobileNumber": mobile
    };
    const options = {
      headers: {
          "Content-Type" : "application/json"
      }
    };

    axios.post(token_url, body , options).then(response => {
      console.log("establishmenttoken response= " + response);
     // props.setToken(response.data.token);
      initiateNewCall(fullName,mobile,registrationNo,response.data.token)
    }).catch(err => {
      console.log(err);
      alert("Error while fetching Est. token");   
    });
  }




  return (
    <div id="main">
      <div className="main-container">
        <div className="row">
          <div className="col-md-12" >
            <h2 data-i18n="virtual_head">
              خدمة الزيارة الافتراضية
              <span className="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-headset" viewBox="0 0 16 16">
                  <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5z"></path>
                </svg>
              </span>

            </h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div  data-i18n="message">
              تتيح هذه الخدمة إمكانية عقد زيارة افتراضية والتواصل مع موظف خدمة العملاء عبر الاتصال المرئي لتنفيذ المطلوب بكل سهولة ويسر
            </div>
          </div>
        </div>
        <hr></hr>
        <div className="row">
          <div className="col-md-12"><h2 data-i18n="activate_mic_camera">حتى نتمكن من خدمتك الرجاء تفعيل الكاميرا والميكروفون</h2></div>
        </div>
        <div className="row" id="speakerListDiv" style={{ display: "none" }}>
          <div className="col-md-6  startupList"  >
            <span data-i18n="mic">جهاز الصوت</span>
            <select id="speakerList" className="select-form"></select>
          </div>
        </div>

        <div className="row" >
          <div className="col-md-6  startupList"  >
            <span data-i18n="microphone">ميكروفون</span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <select style={{ display: "none" }} id="micList" className="select-form"></select>
            {/*<button className="btn btn-block btn-success" onClick={event => this.requestPermission('microphone')} id="microphoneState" style={{display:'none'}}>تفعيل</button>
                         */}
            
            <label id="microphoneState" style={{ display: 'none' }} className="switch"><input type="checkbox" onClick={event => requestPermission('microphone')} /><span className="slider round"></span></label>
          </div>
        </div>

        <div className="row" >
          <div className="col-md-6  startupList" >
            <span data-i18n="camera">الكاميرا</span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <select style={{ display: "none" }} id="cameraList" className="select-form"></select>
            {/*
                            <button className="btn btn-block btn-success" onClick={event => this.requestPermission('camera')} id="cameraState" style={{display:'none'}}>تفعيل</button>
                            */}
            <br></br>
            <label id="cameraState" style={{ display: 'none' }} className="switch"><input type="checkbox" onClick={event => requestPermission('camera')} /><span className="slider round"></span></label>
          </div>
        </div>


        <div className='row' >
          <div  className='col-md-12 text-center' >
            <Stack className={mainContainerStyle} horizontalAlign="center" verticalAlign="center">
              <br />
              {props.deviceManager ? (

                <Stack
                  className={props.screenWidth > 750 ? fullScreenStyle : verticalStackStyle}
                  horizontal={props.screenWidth > 750}
                  horizontalAlign="center"
                  verticalAlign="center"
                  tokens={props.screenWidth > 750 ? configurationStackTokens : undefined}
                >

                  <LocalPreview
                    mic={props.mic}
                    setMic={props.setMic}
                    setLocalVideoStream={props.setLocalVideoStream}
                    videoDeviceInfo={props.videoDeviceInfo}
                    audioDeviceInfo={props.audioDeviceInfo}
                    localVideoStream={props.localVideoStream}
                    videoDeviceList={props.videoDeviceList}
                    audioDeviceList={props.audioDeviceList}
                  />

                  <Stack className={localSettingsContainerStyle}>


                    <LocalSettings
                      videoDeviceList={props.videoDeviceList}
                      audioDeviceList={props.audioDeviceList}
                      audioDeviceInfo={props.audioDeviceInfo}
                      videoDeviceInfo={props.videoDeviceInfo}
                      setVideoDeviceInfo={props.setVideoDeviceInfo}
                      setAudioDeviceInfo={props.setAudioDeviceInfo}
                      deviceManager={props.deviceManager}
                    />



                  </Stack>

                </Stack>
              ) : (
                <Spinner label={spinnerLabel} ariaLive="assertive" labelPosition="top" />
              )}
            </Stack>
          </div>
          </div>
       

          <div className='row'>

            <div  className='col-md-12 text-center'   >
            <PrimaryButton
                    id="startCallBtn"
                    className={buttonStyle}
                    style={{ backgroundColor: "#662577" }}
                    onClick={async () => {
                      if (callStarted) return;
                      callStarted = true;
                      let callBtn = document.getElementById("startCallBtn") as HTMLButtonElement;
                      callBtn?.setAttribute("disabled", "disabled");
                      callBtn.style.backgroundColor = "#CCCCCC";
                       
                      const queryParams = new URLSearchParams(window.location.search)
                      let fullName = queryParams.get("fullname");
                      let mobile = queryParams.get("mobile");
                      let registrationNo = queryParams.get("registrationNo");
                     
                      if(fullName == null) fullName = "";
                      if(mobile == null) mobile = "";
                      if(registrationNo == null) registrationNo = "";
                      fetchEstablishmentToken(fullName, mobile, registrationNo);
                   

                    }}
                    data-i18n="start_comm"
                  >
                {buttonText}
              </PrimaryButton>
            </div>

          </div>
      </div>

    </div>
  );


}




